import { PluginExtensionExposedComponents } from '@grafana/data';

export const ADD_TO_DASHBOARD_COMPONENT_ID =
  PluginExtensionExposedComponents?.AddToDashboardFormV1 || 'grafana/add-to-dashboard-form/v1';

export const ADD_TO_DASHBOARD_LABEL = 'Add to dashboard';
